<!-- Popup Template -->
<ng-template #popupContent>
  <!-- Scoped modal overrides for header-popup-modal -->
  <style>
    /* Make the built-in modal shell fully transparent */
    .header-popup-modal { background: transparent !important; }
    .header-popup-modal .modal-dialog { max-width: 600px !important; margin: 0 auto !important; }
    .header-popup-modal .modal-content,
    .header-popup-modal .modal-header,
    .header-popup-modal .modal-body,
    .header-popup-modal .modal-footer { background: transparent !important; border: 0 !important; box-shadow: none !important; }
    .header-popup-modal .modal-content { border-radius: 0 !important; overflow: visible !important; }
    .header-popup-modal .modal-body { padding: 0 !important; }
    /* Darker dim layer */
    .modal-backdrop.show { opacity: .6; }
  </style>
  <div style="position:relative; background:#0f172a; color:#e5e7eb; border-radius:2px; padding:22px 22px 24px; box-shadow: 0 20px 60px rgba(0,0,0,0.4); min-width: 320px; max-width: 560px; overflow:hidden; background-clip: padding-box;">
    <!-- Close X -->
    <button type="button" aria-label="Close" (click)="closePopup()"
            style="position:absolute; top:10px; right:12px; width:36px; height:36px; border-radius:50%; border:none; background:rgba(255,255,255,0.08); color:#e5e7eb; font-size:18px; font-weight:700; cursor:pointer; line-height:1; display:inline-flex; align-items:center; justify-content:center;">
      &times;
    </button>

    <!-- Content -->
    <div style="display:flex; flex-direction:column; gap:14px;">
      <!-- Icon badge -->
      <div style="width:54px; height:54px; border-radius:12px; background:linear-gradient(135deg,#f59e0b,#ef4444); display:grid; place-items:center; color:#0f172a; font-size:22px;">
        <i class="fas fa-user-slash"></i>
      </div>

      <!-- Title -->
      <h2 style="margin:0; color:#ffffff; font-weight:800; letter-spacing:0;">Your profile is inactive</h2>

      <!-- Subtitle -->
      <p style="margin:0; color:#cbd5e1; line-height:1.6;">Activate your account to appear in search, chat with others, and access all features.</p>

      <!-- Actions -->
      <div style="margin-top:6px;">
        <button (click)="activateProfile()"
                style="background:linear-gradient(90deg,#f59e0b,#fbbf24); border:none; color:#0f172a; font-weight:800; padding:10px 16px; border-radius:8px; box-shadow:0 8px 20px rgba(245,158,11,0.35);">
          Activate Now
        </button>
      </div>
    </div>
  </div>
</ng-template>

<nav *ngIf="login =='yes'" class="navbar navbar-expand-sm main-backgroundcolor">


    <!-- <div style="position: relative;">
        <div class="display justify-content" style="align-items: center;">
            <div class="cursor">
                <a> <img style="height:40px;" src="assets/Ravel-Logo.png"></a>
            </div>
            <div class="text">
                <h4 class="color">Fellowship</h4>

            </div>
        </div>

    </div> -->
    <div class="image-container">
        <a> <img style="height:40px;" src="assets/Ravel-Logo.png"></a>
        <h4 class="color">Ministry</h4>

    </div>


</nav>

<div *ngIf="login !='yes'" style="position: relative; height: 110px;"
    class="header myheader main-backgroundcolor color margin-b">
    <div class="row">
        <div class="col-md-12">
            <div class="display" style="justify-content: space-between;align-items: center;">
                <div routerLink="/alerts" class="cursor" style="margin-top: 20px;">
                    <a> <img style="height:50px;" src="assets/Ravel-Logo.png"></a>
                </div>


                <div class="text" routerLink="/alerts">
                    <div class="image-container" style="
                    margin-top: 25px;">
                        <div class="image-wrapper">
                            <img [src]="setUrl(communityData?.photo)"
                            (error)="onImgError($event)"
                            >
                        </div>
                        <h4 class="color mt-2">{{communityData?.name}}</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>

</div>
